import type { StoreGeneric } from 'pinia';
import { getCurrentInstance } from 'vue';

/** Adds lifecycle hooks to Pinia stores. */
export function useLifecycleHooks<SS extends StoreGeneric>(store: SS): SS {
    const component = getCurrentInstance();
    if (component != null && 'trackStoreUsedByComponent' in store) store.trackStoreUsedByComponent(component);

    return store;
}
